import React from 'react';

export const LegendPrivateBetaMiniIcon = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    width="16"
    height="11"
    viewBox="0 0 16 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.766789 9.888V0.956C0.766789 0.872 0.780789 0.843999 0.850789 0.843999C1.42479 0.83 2.53079 0.802 3.59479 0.802C6.42279 0.802 7.40279 2.37 7.40279 3.896C7.40279 6.164 5.65279 7.13 3.49679 7.13C3.11879 7.13 3.03479 7.13 2.69879 7.13V9.888C2.69879 9.958 2.67079 10 2.58679 10H0.864789C0.794789 10 0.766789 9.958 0.766789 9.888ZM2.69879 2.524V5.408C2.93679 5.422 3.09079 5.422 3.48279 5.422C4.58879 5.422 5.47079 5.086 5.47079 3.938C5.47079 3.056 4.86879 2.496 3.65079 2.496C3.20279 2.496 2.82479 2.51 2.69879 2.524ZM8.73749 9.874V0.983999C8.73749 0.899999 8.75149 0.857999 8.82149 0.843999C9.31149 0.83 10.6835 0.802 11.6775 0.802C14.6595 0.802 15.1495 2.328 15.1495 3.252C15.1495 4.204 14.6455 4.778 14.2955 5.03C14.8135 5.296 15.5975 5.898 15.5975 7.186C15.5975 8.894 14.1135 10.028 11.7055 10.028C10.3475 10.028 9.35349 10.014 8.83549 10C8.76549 9.986 8.73749 9.944 8.73749 9.874ZM10.6415 6.08V8.376C10.9355 8.39 11.2435 8.404 11.6635 8.404C12.8675 8.418 13.5815 8.026 13.5815 7.214C13.5815 6.738 13.3855 6.332 12.7275 6.164C12.5035 6.108 12.1955 6.08 11.8455 6.08H10.6415ZM10.6415 2.468V4.414H11.5935C12.0695 4.414 12.6295 4.456 12.8395 4.484C13.0915 4.26 13.2595 3.994 13.2595 3.532C13.2595 2.818 12.7275 2.44 11.6635 2.44C11.2295 2.44 10.9495 2.454 10.6415 2.468Z"
      fill={props.fill || '#0265DC'}
    />
  </svg>
);
